import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BusinessCodesComponent } from './business-codes.component';

const routes: Routes = [
  {
    path: '',
    component: BusinessCodesComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusinessCodesRoutingModule { }
